import type { BeforeSendFn } from 'posthog-js';

// Microsoft Outlook's SafeLinks scanner pre-renders emailed links inside a
// CefSharp (headless Chromium) browser; its object-binding bridge emits this
// rejection. It is bot noise, not an application error — drop it before send.
const CEFSHARP_NOISE_SIGNATURE = 'Object Not Found Matching Id';

export const dropBotNoiseExceptions: BeforeSendFn = (captureResult) => {
  if (captureResult === null || captureResult.event !== '$exception') {
    return captureResult;
  }

  const exceptionList: unknown = captureResult.properties.$exception_list;
  const serialized = JSON.stringify(exceptionList ?? '');

  return serialized.includes(CEFSHARP_NOISE_SIGNATURE) ? null : captureResult;
};
